import { render, staticRenderFns } from "./homepage.tb.corporate-benefit.vue?vue&type=template&id=06bd0805&scoped=true"
import script from "./homepage.tb.corporate-benefit.vue?vue&type=script&lang=js"
export * from "./homepage.tb.corporate-benefit.vue?vue&type=script&lang=js"
import style0 from "./homepage.tb.corporate-benefit.vue?vue&type=style&index=0&id=06bd0805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd0805",
  null
  
)

export default component.exports